function escapeCSV(value) {
  if (value == null) return ''
  const str = String(value)
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

function formatDate(dateStr) {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  const date = d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
  const time = d.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
  return `${date}, ${time}`
}

function formatAvg(value) {
  if (value == null) return ''
  return Number(value).toFixed(2)
}

/**
 * Export submissions summary data as a CSV file download.
 * @param {Array} submissions - Array of respondent_summary rows
 */
export function exportSubmissionsToCSV(submissions) {
  const headers = [
    'Name', 'Email', 'Sex', 'Age',
    'Partner Name', 'Partner Email',
    'Facilitator',
    'Submitted At',
    'DCI Total',
    'DCI 1 Avg', 'DCI 2 Avg', 'DCI 3 Avg', 'DCI 4 Avg', 'DCI 5 Avg', 'DCI 6 Avg', 'DCI Overall Avg',
    'PI 1 Avg', 'PI 2 Avg', 'PI 3 Avg', 'PI 4 Avg', 'PI 5 Avg', 'PI 6 Avg',
    'Total Likert Responses',
  ]

  const rows = submissions.map(s => [
    escapeCSV(s.name),
    escapeCSV(s.email),
    escapeCSV(s.biological_sex),
    s.age ?? '',
    escapeCSV(s.partner_name),
    escapeCSV(s.partner_email),
    escapeCSV(s.facilitator_name),
    formatDate(s.completed_at),
    s.dci_total ?? '',
    formatAvg(s.dci1_avg),
    formatAvg(s.dci2_avg),
    formatAvg(s.dci3_avg),
    formatAvg(s.dci4_avg),
    formatAvg(s.dci5_avg),
    formatAvg(s.dci6_avg),
    formatAvg(s.dci_overall_avg),
    formatAvg(s.pi1_avg),
    formatAvg(s.pi2_avg),
    formatAvg(s.pi3_avg),
    formatAvg(s.pi4_avg),
    formatAvg(s.pi5_avg),
    formatAvg(s.pi6_avg),
    s.total_likert_responses ?? '',
  ])

  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.join(',')),
  ].join('\n')

  const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `csi-submissions-${new Date().toISOString().split('T')[0]}.csv`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
